module.exports = __webpack_public_path__ + "img/c5201812-1.8e76dc17.jpg";